﻿import { booking_confirmation_payment } from "./booking_confirmation_payment";
import { booking_note } from "./booking_note";

export class booking_confirmation {
    booking_notes: booking_note[] = [];
    reference: string | null = null;
    payment: booking_confirmation_payment = new booking_confirmation_payment();
}